<template>
  <el-dialog title="新增" :visible.sync="newDialogVisible" center @before-close="dialogClose" :close-on-click-modal="false">
    <div class="nav">
      <div class="navContainer" style=" display: inline-block; margin-bottom: 10px">
        <p style="width: 90px; display: inline-block; text-align: right">对账单编号：</p>
        <el-input v-model="billData.setNo" size="mini" style="width: 160px" placeholder="请输入对账单编号" />
      </div>
      <div class="navContainer" style=" display: inline-block; margin-bottom: 10px">
        <p style="width: 90px; display: inline-block; text-align: right">公司名称：</p>
        <el-input v-model="billData.companyName" size="mini" style="width: 150px" placeholder="请输入公司名称" />
      </div>
      <div class="navContainer" style="display: inline-block; margin-bottom: 10px">
        <p style="width: 90px; display: inline-block; text-align: right">公司类型：</p>
          <el-select v-model='billData.companyType' style="width: 160px" filterable size='mini'
                     placeholder='请选择公司类型'>
            <el-option label='全部' value=''></el-option>
            <el-option label='供应商' value='1'></el-option>
            <el-option label='委托商' value='2'></el-option>
          </el-select>
      </div>
      <div class="navContainer" style=" display: inline-block; margin-bottom: 10px">
        <p style="width: 120px; display: inline-block; text-align: right">港口/库房名称：</p>
        <el-input v-model="billData.name" size="mini" style="width: 150px" placeholder="请输入港口/库房名称" />
      </div>
      <div class="navContainer" style=" display: inline-block; margin-bottom: 10px">
        <p style="width: 60px; display: inline-block; text-align: right">品牌：</p>
        <el-input v-model="billData.brand" size="mini" style="width: 200px" placeholder="请输入品牌" />
      </div>
      <div class="navContainer" style="display: inline-block; margin-bottom: 10px">
        <p style="width: 90px; display: inline-block; text-align: right">作业类型：</p>
        <el-input v-model="billData.taskType" size="mini" style="width: 170px" placeholder="请输入作业类型" />
      </div>
      <div class="navContainer" style="display: inline-block; margin-bottom: 10px">
        <p style="width: 90px; display: inline-block; text-align: right">作业时间：</p>
        <el-input v-model="billData.taskDate" size="mini" style="width: 170px" placeholder="请输入作业时间" />
      </div>
      <div class="navContainer" style="display: inline-block; margin-bottom: 10px">
        <p style="width: 100px; display: inline-block; text-align: right">对账调整金额：</p>
        <el-input v-model="billData.adjustPrice" size="mini" style="width: 170px" placeholder="请输入对账调整金额" />
      </div>
      <div class="navContainer" style="display: inline-block; margin-bottom: 10px">
        <p style="width: 60px; display: inline-block; text-align: right">类型：</p>
        <el-select v-model='billData.settlementType' style="width: 160px" filterable size='mini'
                   placeholder='请选择类型'>
          <el-option label='全部' value=''></el-option>
          <el-option label='库房' value='0'></el-option>
          <el-option label='港口' value='1'></el-option>
        </el-select>
      </div>
      <div style="display: inline; margin-left: 10px">
        <el-button size="small" class="searchBtn" @click="onClickSearch">查询</el-button>
      </div>
    </div>
    <div class="tableContent">
      <el-table
        ref="billRef"
        :data="tableDatas"
        @select="handleCurrentChange"
        @selection-change = "handleSelectionChange"
        :row-key="
          row => {
            return row.id;
          }
        "
        v-loading="tableLoad"
        style="width: 100%"
        border
        :header-cell-style="headerCellStyle"
        highlight-current-row>
        <el-table-column type="selection" align="center" width="50px" :reserve-selection="true" />
        <el-table-column property="setType" align="center" label="结算类型" width="139">
          <template slot-scope="scope">{{ scope.row.setType == 1 ? '合同价' : '预结算价' }}</template>
        </el-table-column>
        <el-table-column property="companyName" align="center" label="公司名称" width="139">
          <template slot-scope="scope">
            <span v-if="scope.row.supplierName">{{scope.row.supplierName}}</span>
            <span v-else>{{scope.row.companyName}}</span>
          </template>
        </el-table-column>
        <el-table-column property="companyType" label="公司类型" align="center" min-width="180px" >
          <template slot-scope="scope">{{scope.row.companyType === 1 ? '供应商' : '委托商'}}</template>
        </el-table-column>
        <el-table-column property="name" align="center" label="港口/库房名称" width="139"></el-table-column>
        <el-table-column property="brand" align="center" label="品牌" width="139"></el-table-column>
        <el-table-column property="taskType" align="center" label="作业类型" width="139"></el-table-column>
        <el-table-column property="taskDate" align="center" label="作业时间" width="139"></el-table-column>
        <el-table-column property="settlementType" label="类型" align="center" min-width="180px">
          <template slot-scope="scope">{{scope.row.settlementType === 0 ? '港口' : '库房'}}</template>
        </el-table-column>
        <el-table-column property="taxRate" align="center" label="税率" width="139"></el-table-column>
        <el-table-column property="taxContractPrice" align="center" label="含税合同价" width="139"></el-table-column>
        <el-table-column property="taxPreparePrice" align="center" label="含税预结算价" width="139"></el-table-column>
        <el-table-column property="standingBookMonth" align="center" label="台账月" width="139"></el-table-column>
      </el-table>
    </div>
    <div class="paginationContainer" style="margin-top: 10px">
      <span>共{{ billDataTotal }}条</span>
      <el-pagination :page-sizes="[10, 20, 30, 40]" :page-size="billData.rows" layout=" sizes, prev, pager, next, jumper" :total="billDataTotal" @size-change="billSizeChange" @current-change="billCurrentChange" />
    </div>
    <div class="btnContainer">
      <el-button size="medium" class="searchBtn" :loading="addLoad" @click="onClickAdd">确认</el-button>
      <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  getSupperAdjust, addSupperAdjust
} from '@/service/financial';

export default {
  data() {
    return {
      newDialogVisible: false,
      billData: {
        setNo: '',
        companyType: '',
        name: '',
        brand: '',
        taskType: '',
        taskDate: '',
        settlementType: '',
        adjustPrice: '',
        page: 1,
        rows: 10,
      },
      tableDatas: [],
      tableLoad: false,
      billDataTotal: 0,
      headerCellStyle: {
        color: '#3B3B3B',
        'font-size': '13px',
        height: '50px',
        background: '#E8E8E8',
      },
      addLoad: false,
      currentRow: [],
      data1: null,
    };
  },
  methods: {
    onClickSearch() {
      // console.log('<<<');
      this.getData();
    },
    async getData() {
      this.tableLoad = true;
      const res2 = await getSupperAdjust(this.billData);
      this.tableDatas = res2.data.records;
      this.billDataTotal = res2.data.total;
      this.tableLoad = false;
    },
    dialogNewClose() {},
    openDialog() {
      this.tableLoad = false;
      this.billData = {
        setNo: '',
        companyName: '',
        companyType: '',
        name: '',
        brand: '',
        taskDate: '',
        taskType: '',
        settlementType: '',
        adjustPrice: '',
        page: 1,
        rows: 10,
      };
      this.tableDatas = [];
      this.currentRow = [];
      this.newDialogVisible = true;
    },
    billSizeChange(sizes) {
      this.billData.rows = sizes;
      this.getData();
    },
    billCurrentChange(page) {
      this.billData.page = page;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    handleSelectionChange(val){
      this.currentRow = val;
      if (val.length > 1) {
        this.$refs.billRef.clearSelection();
        this.$refs.billRef.toggleRowSelection(val.pop());
      }
    },
    async onClickAdd() {
      const object = this.currentRow.reduce((accumulator, currentValue) => {
        return { ...accumulator, ...currentValue };
      }, {});
      object['customerName'] = this.currentRow.map(item => item.companyName || item.supplierName).join(',');
      object['taxAdjustPrice'] = this.billData['adjustPrice'];
      object['setNo'] = this.billData['setNo'];
      const res = await addSupperAdjust(object);
      if (res.status !== 0) return this.$message.warning(res.message);
      this.$message.success(res.message);
      this.newDialogVisible = false;
    },
    dialogClose() {
      this.newDialogVisible = false;
    },
  },
};
</script>
<style scoped lang="scss">
.el-pagination {
  white-space: nowrap;
  margin: -22px 43px 10px;
  color: #303133;
  font-weight: 700;
}
</style>
